import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import React, { useContext } from 'react'
import './EstiloPages.css'
import { globalContext } from '../Context/GlobalContext'

export const SelectorCatalogo = () => {
  const { colorTheme, country } = useContext(globalContext)
  const catalogoENG = process.env.PUBLIC_URL + "/pdf/catalogo2026digital_compressed.pdf"
  const catalogoESP = process.env.PUBLIC_URL + "/pdf/catalogo2026digital_compressed.pdf"
  const catalogoDO = process.env.PUBLIC_URL + "/pdf/catalogo2026digital_compressed.pdf"
  const catalogoZebra = process.env.PUBLIC_URL + "/pdf/catalogoZebra2.pdf"
  const catalogoUY = process.env.PUBLIC_URL + "/pdf/catalogo2026digital_compressed.pdf"



  return (
    <div>
      <img src={"https://raw.githubusercontent.com/RamiroSB/imagenes/main/rma-banner.png"} alt="Imagen marcas" className='imagenesBody' loading='lazy'></img>
      <Container fluid className={`contAlt bg-${colorTheme}`} style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', paddingTop: 56 }}>
        <h2 className='titleCat animated-title' style={{ textAlign: 'center', margin: '24px 0 32px 0', fontWeight: 700, fontSize: 32, letterSpacing: 1 }}>
          Descargue el catalogo en su idioma
        </h2>

        <div
  className='containerRmaButtons'
  style={{
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: 32,
    marginTop: 14
  }}
>
  {country != "UY" && (
  <a
    href={catalogoESP}
    download
    className="butn5"
    style={{
      minWidth: 200,
      fontSize: 22,
      padding: '38px 36px',
      borderRadius: 12,
      fontWeight: 600,
      paddingBottom: 60,
      margin: 0,
      textAlign: 'center',
      display: 'inline-block',
      textDecoration: 'none'
    }}
  >
    Spanish
  </a>
  )}
  <a
    href={catalogoENG}
    download
    className="butn5"
    style={{
      minWidth: 200,
      fontSize: 22,
      padding: '38px 36px',
      borderRadius: 12,
      fontWeight: 600,
      paddingBottom: 60,
      margin: 0,
      textAlign: 'center',
      display: 'inline-block',
      textDecoration: 'none'
    }}
  >
    English
  </a>
  {country === "DO" && (
    <a
      href={catalogoDO}
      download
      className="butn5"
      style={{
        minWidth: 200,
        fontSize: 22,
        padding: '38px 36px',
        borderRadius: 12,
        fontWeight: 600,
        paddingBottom: 60,
        margin: 0,
        textAlign: 'center',
        display: 'inline-block',
        textDecoration: 'none'
      }}
    >
      Catálogo Retail
    </a>
  )}
  {country === "UY" && (
    <a
      href={catalogoUY}
      download
      className="butn5"
      style={{
        minWidth: 200,
        fontSize: 22,
        padding: '38px 36px',
        borderRadius: 12,
        fontWeight: 600,
        paddingBottom: 60,
        margin: 0,
        textAlign: 'center',
        display: 'inline-block',
        textDecoration: 'none'
      }}
    >
      Catálogo ESP
    </a>
  )}
  {(country === "ARG" || country === "UY" || country === "PY") && (
    <a
      href={catalogoZebra}
      download
      className="butn5"
      style={{
        minWidth: 200,
        fontSize: 22,
        padding: '38px 36px',
        borderRadius: 12,
        fontWeight: 600,
        paddingBottom: 60,
        margin: 0,
        textAlign: 'center',
        display: 'inline-block',
        textDecoration: 'none'
      }}
    >
      Catalogo Zebra
    </a>
  )}
</div>
        
      </Container>
    </div>
  )
}